import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { masterRefilling } from "../../rbac-consts";
import MasterRefillingsContainer from "./master/MasterRefillingsContainer";

const MasterRefillingsWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={masterRefilling.MASTER}
      yes={() => (
        <MasterRefillingsContainer />
      )}
    />
  );
};

export default MasterRefillingsWrapper;